// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2x05R","calendarButtons":"ClockData_calendarButtons__1sQlc"};